import React from "react";
import { useDispatch } from "react-redux";

import { IgButton } from "@intelligems/ig-theme";
import { FullAgencyDto } from "@intelligems/ig-types";
import { Grid } from "@mui/material";
import { AgencyCustomersTable } from "@src/features/admin/pages/agencies/components/Tables/AgencyCustomersTable/AgencyCustomersTable";
import { openDrawer } from "@src/store/slices/drawers";

interface CustomersTabProps {
  agency: FullAgencyDto;
}
export const CustomersTab = ({ agency }: CustomersTabProps) => {
  const dispatch = useDispatch();
  return (
    <Grid
      container
      item
      direction={"column"}
      sx={{ padding: "15px" }}
      rowSpacing={2}
    >
      <Grid item>
        <AgencyCustomersTable agency={agency} />
      </Grid>
      <Grid item textAlign={"end"}>
        <IgButton
          variant={"contained"}
          onClick={() => {
            dispatch(
              openDrawer({
                type: "addCustomerGroup",
                agency,
              })
            );
          }}
        >
          Link Customer to Agency
        </IgButton>
      </Grid>
    </Grid>
  );
};
